import PixelObject from './PixelObject'

export default class Grid extends PixelObject {
    constructor(options) {
        super(options);

        const defaults = {
            type: 'GRID',
            name: 'Grid',
            col: 3,
            rows: 3,
            cellWidth: 50,
            cellHeight: 50
        }

        let opts = { ...defaults, ...options }

        this.type = opts.type
        this.name = opts.name
        this.col = opts.col
        this.rows = opts.rows
        this.cellWidth = opts.cellWidth
        this.cellHeight = opts.cellHeight
    }

    set(key, newValue) {
        if (PixelObject.prototype.set.call(this, key, newValue) == undefined) {
            return;
        }

        const data = {
            oldValue: this[key],
            newValue
        }

        switch (key) {
            case 'col': {
                this.col = newValue
                break;
            }
            case 'rows': {
                this.rows = newValue
                break;
            }
            case 'cellWidth': {
                this.cellWidth = newValue
                break;
            }
            case 'cellHeight': {
                this.cellHeight = newValue
                break;
            }
            default: {
                return false
            }
        }
    }

    get (key) {
        switch (key) {
            case 'width': {
                return this.cellWidth * this.col
            }
            case 'height': {
                return this.cellHeight * this.rows
            }
        }
        return PixelObject.prototype.get.call(this, key)
    }

    copy(args) {
        return new Grid({ ...this, ...args, skipParentGeneration: true })
    }

    draw() {
        if (this.visible == '0' || this.deleted) return
        
        this.ctx.push()
        this.position()
        this.ctx.translate(-this.get('width') / 2, -this.get('height') / 2)

        for (let x = 0; x < this.col; x++) {
            for (let y = 0; y < this.rows; y++) {
                this.ctx.push()
                this.ctx.translate(this.cellWidth * x, this.cellHeight * y)

                for (var i = this.children.length - 1; i >= 0; i--) {
                    const child = this.children[i];
                    child.draw()
                }
                this.ctx.pop()
            }
        }

        //PixelObject.showBoundingBox(0, 0, width, height, this.selected)

        this.ctx.pop()
    }
}